import dxLogo from '../assets/image/dxinterior-logo.svg';

/**
 * Preloader shown after successful login - white background,
 * centered logo with fade in/out animation for 5s, then fades out to dashboard
 */
const Preloader = ({ isFadingOut }) => (
  <div
    className={`fixed inset-0 z-[100] flex items-center justify-center bg-white ${
      isFadingOut ? 'animate-preloader-fade-out' : ''
    }`}
  >
    <img
      src={dxLogo}
      alt="DX Interiors"
      className="h-16 w-auto animate-preloader-fade"
    />
  </div>
);

export default Preloader;
